import type { VisitorReceptionTarget } from "../../../features/Admin/components/visitor-reception-api.logic";
import {
  postConferenceVisitorCheckIn,
  postConferenceVisitorCheckOut,
  postConferenceVisitorReject
} from "./conference-visitor-registration-actions.api";
import {
  postVisitOnlyCheckIn,
  postVisitOnlyCheckOut,
  postVisitOnlyReject
} from "./visit-only-visit-actions.api";

export type VisitorReceptionRejectPayload = {
  target: VisitorReceptionTarget;
  reason?: string;
};

function rejectBody(reason?: string): { reason?: string } | undefined {
  if (reason === undefined || reason.length === 0) {
    return undefined;
  }
  return { reason };
}

export const postVisitorReceptionCheckIn = (target: VisitorReceptionTarget) => {
  if (target.kind === "place") {
    return postVisitOnlyCheckIn(target.visitId);
  }
  return postConferenceVisitorCheckIn(target.visitorRegistrationId);
};

export const postVisitorReceptionCheckOut = (target: VisitorReceptionTarget) => {
  if (target.kind === "place") {
    return postVisitOnlyCheckOut(target.visitId);
  }
  return postConferenceVisitorCheckOut(target.visitorRegistrationId);
};

export const postVisitorReceptionReject = ({ target, reason }: VisitorReceptionRejectPayload) => {
  const body = rejectBody(reason);
  if (target.kind === "place") {
    return postVisitOnlyReject(target.visitId, body);
  }
  return postConferenceVisitorReject(target.visitorRegistrationId, body);
};
